import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import Dialog, { DialogProps } from '../common/Dialog';
import Flex from '../common/Flex';
import { TextRegular } from '../common/Text';
import { AddCircle } from '../common/Icons';
import Box from '../common/Box';
import CentralizeButton from '../../VuexyDesign/atoms/CentralizeButton';

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background-image: url(/static/images/vcoin/vcoin-banner.svg);
    background-repeat: no-repeat;
    background-size: 85%;
  }
`;

const NoVCoinsDialog = ({
  onClose,
  inWidget = false,
  ...props
}: { inWidget?: boolean } & Omit<DialogProps, 'children'>) => {
  const { t } = useTranslation('modals');

  return (
    <StyledDialog disableFullScreen {...props} onClose={onClose}>
      <Flex
        width="100%"
        height="100%"
        flexDirection="column"
        alignItems="center"
        justifyContent={['space-between', 'center']}
        px={4}
        py={4}
        mt="30%"
      >
        <Flex
          flexDirection="column"
          alignItems={['center']}
          justifyContent={['flex-start', 'center']}
          flex={1}
        >
          <Flex
            mb={3}
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
          >
            <TextRegular
              as="h3"
              m={0}
              mb={2}
              fontSize={[5, 8]}
              fontWeight="bold"
              textAlign="center"
            >
              {t('modals:hello')}
            </TextRegular>
          </Flex>
          <Box display={['none', 'initial']}>
            <TextRegular
              mb={4}
              fontSize={[2, 3]}
              lineHeight={[2, 1.5]}
              textAlign="center"
            >
              {t('modals:howToGetVcoins')}
            </TextRegular>
          </Box>
        </Flex>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {inWidget ? (
            <a
              href="https://virpp.com/my-wallet"
              target="_blank"
              rel="noreferrer"
            >
              <Flex mb={3} as="button" type="button" alignItems="center">
                <Box mr={2}>
                  <AddCircle size={22} />
                </Box>
                {t('modals:getMoreVcoins')}
              </Flex>
            </a>
          ) : (
            <Link href="/my-wallet" legacyBehavior>
              <a target="_blank">
                <Flex mb={3} alignItems="center">
                  <CentralizeButton
                    icon={AddCircle}
                    isIconLeftSide
                    text={t('modals:getMoreVcoins') as string}
                    color="primary"
                    size="md"
                  />
                </Flex>
              </a>
            </Link>
          )}
        </Flex>
      </Flex>
    </StyledDialog>
  );
};

export default NoVCoinsDialog;
